// Packages
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  dialogContent: {
    marginTop: 1,
    height: 340,
  },
  container: {
    flexGrow: 1,
    position: "relative",
  },
  suggestContainer: {},
  suggestItem: {},
  addressLine2: {
    marginTop: 8,
    marginBottom: 8,
  },
  addressField: {
    marginTop: 10,
  },
  badState:{
    marginTop: 10,
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  chip: {
    margin: `${theme.spacing(1) / 2}px ${theme.spacing(1) / 4}px`,
  },
  inputRoot: {
    flexWrap: "wrap",
  },
  inputInput: {
    width: "auto",
    flexGrow: 1,
  },
  divider: {
    height: theme.spacing(2),
  },
}));
